import React, { useEffect } from 'react'
import { useState } from "react";

import { makeStyles } from '@material-ui/core/styles';

import LoadingComponent from '../../../../components/Loading';

import { useSelector } from "react-redux";

import {
    selectUsuarioSeleccionado,
} from "../../../../redux/reducer/loginReducer";
import EmptyComponent from '../../../../components/EmptyContent';
// import { deleteInquilino, getAlumnos, inquilinoDelete } from '../../../../services/Alumnos';
import { Box, Button, Grid, IconButton, Menu, MenuItem, TextField, Typography } from '@material-ui/core';
// import { DataGrid, GridActionsCellItem, GridToolbarDensitySelector, GridToolbarFilterButton} from '@mui/x-data-grid';
import { useHistory } from 'react-router-dom';
import ClearIcon from '@material-ui/icons/Clear';
import SearchIcon from '@material-ui/icons/Search';
import PropTypes from 'prop-types';
import { deleteEnviosPostalesSeleccionados, enviarEnviosPostalesSeleccionados, enviosPostalesUploadCsvCorreos, getAlumnosRegistrados, getLeadsEnviosPostales } from '../../../../services/alumnos';
import Moment from 'react-moment';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { BASE_URL_SERVICE } from '../../../../constants';
import { DataGridPro, GridToolbarDensitySelector, GridToolbarFilterButton, useGridApiContext, useGridApiRef } from '@mui/x-data-grid-pro';
import useDataGridFilterPersist from '../../../../hooks/useDataGridFilterPersist';

function escapeRegExp(value) {
    return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
  }

// import Moment from 'react-moment';

/* -------------------------------------------------------------------------- */
/*                                   Estilos                                  */
/* -------------------------------------------------------------------------- */
const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: '80px'
    },
    loadingContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "90vh"
    },
    emptyContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "80vh",
        width: '100%',
        flexDirection: 'column',
        textAlign: 'center'
    },
    emptyImage: {
        width: '100%'
    },
    rootFilter: {
        padding: theme.spacing(0.5, 0.5, 0),
        justifyContent: 'space-between',
        display: 'flex',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
      },
    textFieldFilter: {
        [theme.breakpoints.down('xs')]: {
          width: '100%',
        },
        margin: theme.spacing(1, 0.5, 1.5),
        '& .MuiSvgIcon-root': {
          marginRight: theme.spacing(0.5),
        },
        '& .MuiInput-underline:before': {
          borderBottom: `1px solid ${theme.palette.divider}`,
        },
      },
    enlace: {
      color: theme.palette.link.main,
      textDecoration: 'none'
    }
}));

export default function AlumnosEnviosPostalesContent() {
    const classes = useStyles();

    const [Alumnos, setAlumnos] = useState([]);
    const [loading, setLoading] = useState(false)
    const [loadingMensaje, setLoadingMensaje] = useState("")

    const usuarioSeleccionado = useSelector(state => {
        return selectUsuarioSeleccionado(state);
    });
    const history = useHistory()

    /* -------------------------------------------------------------------------- */
    /*                                  UseEffect                                 */
    /* -------------------------------------------------------------------------- */
    useEffect(() => {
        setLoading(true)
        setLoadingMensaje("Cargando alumnos")

        const usuario_id = usuarioSeleccionado.id

        getLeadsEnviosPostales({ usuario_id }).then((response) => {

            response && setAlumnos(response.alumnos)
            setLoading(false)

        });

        // getComerciales({usuario_id: usuario_id}).then( (response) => {
        //     response.comerciales && setComerciales(response.comerciales)
        // })
    }, [])

    /* -------------------------------------------------------------------------- */
    /*                           Definicion de columnas                           */
    /* -------------------------------------------------------------------------- */

    const columnas = 
    [
      { field: 'id', hide: false, headerName: 'ID' },
      { field: 'nombre', headerName: 'Nombre', minWidth: 250, flex: 1 },
      { field: 'status_nombre', headerName: 'Estado', minWidth: 150 },
      { field: 'ultimo_envio_estado', headerName: 'Estado envio', minWidth: 150 },
      { field: 'fecha_ultimo_envio_estado', headerName: 'Fecha ultimo envio', minWidth: 150, renderCell: (params) => {
        return params.value ? <Moment format="DD/MM/YYYY">{params.value}</Moment> : '';
      }},
      
      { field: 'direccion', headerName: 'Dirección', minWidth: 350 },
      { field: 'codigo_postal', headerName: 'Código Postal', minWidth: 150 },
      { field: 'ciudad', headerName: 'Ciudad', minWidth: 150 },
      { field: 'provincia', headerName: 'Provincia', minWidth: 150 },

      { field: 'comunidad_autonoma_nombre', headerName: 'Comunidad', minWidth: 150 },
      { field: 'especialidad_nombre', headerName: 'Especialidad', minWidth: 150 },
      { field: 'ultimo_envio_tipo', headerName: 'Ultimo envio', minWidth: 150 },
      // { field: 'ultimo_envio_created', headerName: 'Fecha ultimo envio', minWidth: 150 },
    ]

    /* -------------------------------------------------------------------------- */
    /*                                  Contenido                                 */
    /* -------------------------------------------------------------------------- */
    function QuickSearchToolbar(props) {
        const classes = useStyles();
      
        return (
          <div className={classes.rootFilter}>
            <div>
              <GridToolbarFilterButton />
              <GridToolbarDensitySelector />
              {props.selectedRows && props.selectedRows.length > 0 && (
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  style={{ marginLeft: 8 }}
                  onClick={props.onButtonClickDelete}
                >
                  Eliminar Envios Seleccionados ({props.selectedRows.length})
                </Button>
              )}
              {props.selectedRows && props.selectedRows.length > 0 && (
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  style={{ marginLeft: 8 }}
                  onClick={props.onButtonClickEnviar}
                >
                  Enviar Seleccionados ({props.selectedRows.length})
                </Button>
              )}
            </div>
            <TextField
              variant="standard"
              value={props.value}
              onChange={props.onChange}
              placeholder="Buscar…"
              className={classes.textFieldFilter}
              InputProps={{
                startAdornment: <SearchIcon fontSize="small" />,
                endAdornment: (
                  <IconButton
                    title="Clear"
                    aria-label="Clear"
                    size="small"
                    style={{ visibility: props.value ? 'visible' : 'hidden' }}
                    onClick={props.clearSearch}
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                ),
              }}
            />
          </div>
        );
      }
      
      QuickSearchToolbar.propTypes = {
        clearSearch: PropTypes.func.isRequired,
        onChange: PropTypes.func.isRequired,
        value: PropTypes.string.isRequired,
        selectedRows: PropTypes.array,
        onButtonClick: PropTypes.func,
      };

    const Contenido = () => {
        const [rows, setRows] = React.useState(Alumnos);
        const [searchText, setSearchText] = React.useState('');
        const [selectionModel, setSelectionModel] = React.useState([]);
        
        const requestSearch = (searchValue) => {
          // console.log(searchValue)
          setSearchText(searchValue);
          const searchRegex = new RegExp(escapeRegExp(searchValue), 'i');
          // const searchRegex = new RegExp(`.*${searchValue}.*`, 'ig');
          const filteredRows = Alumnos.filter((row) => {
              return Object.keys(row).some((field) => {
                  // console.log(field)
                  // console.log(row)
                  return searchRegex.test(row[field]);
              });
          });
          setRows(filteredRows);
        };

        const handleAlumnoDetalle = (id) => {
          history.push('alumnos/detalle/' + id )
        }
        const [anchorElOpciones, setAnchorElOpciones] = React.useState(null);
        const open = Boolean(anchorElOpciones);
      
        const handleClickOpciones = (event) => {
          setAnchorElOpciones(event.currentTarget);
        };
      
        const handleCloseOpciones = () => {
          setAnchorElOpciones(null);
        };

        const handleGenerarFicheroFormatoUnico = () => {
          setAnchorElOpciones(null);
        }

        const handleEliminarEnviosSeleccionados = () => {
          console.log('Eliminando registros seleccionados:', selectionModel);

          deleteEnviosPostalesSeleccionados({usuario_id: usuarioSeleccionado.id, alumnos_id: selectionModel}).then((response) => {
              // Refrescar la lista de envios postales después de eliminar
              const usuario_id = usuarioSeleccionado.id;
              getLeadsEnviosPostales({ usuario_id }).then((response) => {
                response && setAlumnos(response.alumnos);
                setSelectionModel([]); // Limpiar selección después de eliminar
              });
          })
        }
        const handleEnviarSeleccionadosSeleccionados = () => {
          console.log('Enviando registros seleccionados:', selectionModel);

          enviarEnviosPostalesSeleccionados({usuario_id: usuarioSeleccionado.id, alumnos_id: selectionModel}).then((response) => {
              // Refrescar la lista de envios postales después de eliminar
              if (response?.data) {
                const now = new Date();
                const dia = String(now.getDate()).padStart(2, '0');
                const mes = String(now.getMonth() + 1).padStart(2, '0');
                const anio = now.getFullYear();
                const hora = String(now.getHours()).padStart(2, '0');
                const minuto = String(now.getMinutes()).padStart(2, '0');
                const segundo = String(now.getSeconds()).padStart(2, '0');

                const filename_aux = `envio_${anio}_${mes}_${dia}_${hora}_${minuto}_${segundo}.txt`;


                const contentDisposition = response.headers?.['content-disposition'] || '';
                const match = contentDisposition.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i);
                const filename = match ? decodeURIComponent(match[1]) : filename_aux;

                const blob = new Blob([response.data], { type: response.headers?.['content-type'] || 'application/octet-stream' });
                const url = window.URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = url;
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
              }

              const usuario_id = usuarioSeleccionado.id;
              getLeadsEnviosPostales({ usuario_id }).then((response) => {
                response && setAlumnos(response.alumnos);
                setSelectionModel([]);
              });
          })
        }

        const [filterModel, onFilterModelChange] = useDataGridFilterPersist('alumnos_registrados_page','alumnos_registrados')

        return (
            rows ?
                <>
                  <Box mt={12} mb={3} mx={2} display="flex" alignItems="center" flexWrap="wrap" gridGap={16}>
                    <Typography variant="h5" component="h3" gutterBottom display='inline' style={{fontWeight: 500}} >
                        {"Envios postales"}
                    </Typography>

                    <IconButton
                      aria-label="more"
                      aria-controls="long-menu"
                      aria-haspopup="true"
                      onClick={handleClickOpciones}
                    >
                      <MoreVertIcon />
                    </IconButton>

                    <Menu
                      id="long-menu"
                      anchorEl={anchorElOpciones}
                      keepMounted
                      open={open}
                      onClose={handleCloseOpciones}
                      
                    >
                      <MenuItem key="opcion1" onClick={handleGenerarFicheroFormatoUnico}>
                        <a 
                          href={`https://gestion.innovatiio.com/api/test/operaciones?op=CORREOS`} 
                          rel='noreferrer'
                          target='_blank' 
                          style={{textDecoration: 'none'}}>Fichero formato único</a>
                      </MenuItem>
                      
                    </Menu>
                    
                    <Box>
                      <input
                        accept=".txt,.csv,.pdf"
                        style={{ display: 'none' }}
                        id="raised-button-file"
                        type="file"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            console.log('Archivo seleccionado:', file);

                            enviosPostalesUploadCsvCorreos({usuario_id: usuarioSeleccionado.id, file: file}).then((response) => {
                              console.log(response)
                              // if (response) {
                              //   const usuario_id = usuarioSeleccionado.id;
                              //   getLeadsEnviosPostales({ usuario_id }).then((response) => {
                              //     response && setAlumnos(response.alumnos);
                              //   });
                              // }
                            }).catch((error) => {
                              console.error('Error al subir archivo:', error);
                            });
                          }
                        }}
                      />
                      <label htmlFor="raised-button-file">
                        <Button
                          variant="contained"
                          color="primary"
                          component="span"
                          size="small"
                        >
                          Actualizar estado envios postales
                        </Button>
                      </label>
                    </Box>

                  </Box>
                    

    
                    <div style={{ height: 500, width: '100%', padding:"0 15px" }}>
                        <DataGridPro
                          filterModel={ filterModel }
                          onFilterModelChange={ onFilterModelChange }
                          rows={rows} 
                          columns={columnas} 
                          rowHeight={30}
                          checkboxSelection
                          rowSelectionModel={selectionModel}
                          onRowSelectionModelChange={(newSelection) => {
                            setSelectionModel(newSelection);
                          }}
                          slots={{ toolbar: QuickSearchToolbar }}
                          onRowDoubleClick={ (evento ) => handleAlumnoDetalle(evento.id) }
                          slotProps={{
                              toolbar: {
                                value: searchText,
                                onChange: (event) => requestSearch(event.target.value),
                                clearSearch: () => requestSearch(''),
                                selectedRows: selectionModel,
                                onButtonClickDelete: handleEliminarEnviosSeleccionados,
                                onButtonClickEnviar: handleEnviarSeleccionadosSeleccionados
                              },
                          }}
                        />
                    </div>

                    {/* <Typography variant='caption' style={{marginTop: 10, marginLeft: 16}}>NOTA: Ordenado por fecha de entrada de gasto decreciente</Typography> */}

                </>
                
                :
                <EmptyComponent mensaje="No hay datos para mostrar" />
        )
    }
    
    /* -------------------------------------------------------------------------- */
    /*                                   Return                                   */
    /* -------------------------------------------------------------------------- */
    return (
        <div className={classes.container}>
            {
                (loading ?
                    
                    <LoadingComponent isFullScreen={true} mensaje={loadingMensaje} />
                    
                    :
                    
                    <Contenido />
                )
            }
        </div>
    )
}
